import React, { useEffect, useRef } from 'react'
import './TextSelectionPopup.css'

const TextSelectionPopup = ({
    selectedText,
    position,
    // onQuote, // TODO: Implement quote feature
    onExplain,
    onClose,
    visible,
}) => {
    const popupRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose(true) // Clear selection when clicking outside
            }
        }

        if (visible) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [visible, onClose])

    if (!visible || !selectedText) {
        return null
    }

    // TODO: Implement quote feature
    // const handleQuote = () => {
    //     onQuote(selectedText)
    //     onClose()
    // }

    const handleExplainMouseDown = (e) => {
        // It prevents the browser from clearing the text selection when the button is clicked.
        e.preventDefault()
    }

    const handleExplainClick = () => {
        // Now that the selection is preserved, we can safely call onExplain.
        onExplain(selectedText)
        // And then close the popup and clear the selection.
        onClose(true)
    }

    return (
        <div
            className="text-selection-popup"
            ref={popupRef}
            style={{
                left: position.x,
                top: position.y,
            }}
        >
            <div className="popup-content">
                {/* TODO: Implement quote feature */}
                {/* <div className="popup-option" onClick={handleQuote}>
                    <span>Quote</span>
                </div> */}
                <div
                    className="popup-option"
                    onMouseDown={handleExplainMouseDown}
                    onClick={handleExplainClick}
                >
                    <span>Explain</span>
                </div>
            </div>
        </div>
    )
}

export default TextSelectionPopup
